var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFilterIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.395 1.81055H1.60525C1.11306 1.81055 0.805695 2.34693 1.05279 2.77483L5.72556 10.7181V15.5516C5.72556 15.9072 6.01083 16.1945 6.3644 16.1945H11.6358C11.9894 16.1945 12.2747 15.9072 12.2747 15.5516V10.7181L16.9494 2.77483C17.1945 2.34693 16.8872 1.81055 16.395 1.81055ZM10.8363 14.748H7.16395V11.6141H10.8383V14.748H10.8363ZM11.0291 9.99492L10.8383 10.3284H7.16195L6.9711 9.99492L2.98739 3.25698H15.0128L11.0291 9.99492Z",
    fill: "#262626"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFilterIcon);
export default __webpack_public_path__ + "static/media/filterIcon.306c231e648d7432eb88ac1eb3add3d0.svg";
export { ForwardRef as ReactComponent };